import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MajorSegment, PostCodesLocation, SalesRegion, StateProvinceCRM, Territory } from 'src/app/common/model/shared.model';
import { environment } from 'src/environments/environment';
import { CRMReportRequest } from './crm-data-by-zip-territory.component';
import { v4 as uuidv4 } from 'uuid';
import { BatchReportsService } from '../batch-reports-grid/batch-reports-service';
import { Observable, Subject, takeUntil, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})


export class CrmDataByZipTerritoryService {

  baseurl = environment.apiBaseUrl;
  
  constructor(protected http: HttpClient, private batchReportsService: BatchReportsService) { }

  getMajorSegmentList(){
    return this.http.get<MajorSegment[]>(this.baseurl + 'MajorSegment/getmajorsegments');
  }

  getSalesRegionList(){
    return this.http.get<SalesRegion[]>(this.baseurl + 'SalesRegion/getsalesregions');
  }

  getTerritoryListBySalesRegion(salesRegionId: number) {
    return this.http.get<Territory[]>(this.baseurl + `Territory/getterritoriesbysalesregion?salesRegionId=${salesRegionId}`);
  }

  getCountries() {
    return this.http.get<StateProvinceCRM[]>(this.baseurl + `StateProvince/getcountrylist`);
  }

  getPostCodeDetails(countryId: string, postCode: string){
    return this.http.get<PostCodesLocation[]>(this.baseurl 
      + `PostCodesLocation/getpostcodedetails?countryId=${countryId}&postCode=${postCode}`);
  }

  searchPostCode(countryId: string, postCodePartial: string){
    return this.http.get<PostCodesLocation[]>(this.baseurl 
      + `PostCodesLocation/searchpostcode?countryId=${countryId}&postCodePartial=${postCodePartial}`);
  }

  
  getCRMReport(reportRequest: CRMReportRequest, reportType: string){


    switch (reportType) {
      case 'CurrCust_ALLSAP':
        return this.getCurrentCustomerReport_ALLSAP(reportRequest);
      case 'CurrCust_LBSAP':
        return this.getCurrentCustomerReport_LBSAP(reportRequest);
      case 'LeadsOLW_OpenLeadsDetails':
        return this.getLeadsOLWReport_OpenLeadsDetails(reportRequest);      
      case 'LeadsWith91MA_AllLeadsDetails':
        return this.getLeadsWith91MA_AllLeadsDetails(reportRequest);
      case 'CRM_Prospects_With91MA':
        return this.getCRMProspectsWith91MA(reportRequest);
      case 'CRM_Suspects':
        return this.getCRMSuspects(reportRequest);
      case 'Oppty_OpenOpptyDetails':
        return this.getOpptyReport_OpenOpptyDetails(reportRequest);
      case 'OpptysWith91MA_AllOpptysDetails':
          return this.getOpptysWith91MA_AllOpptysDetails(reportRequest);        
      default:
        return;
    }

  }

  shouldExecuteAsJob(reportType: string, reportFilters: CRMReportRequest): {execAsJob: boolean, reportId?: number}{

      if(reportType == 'CurrCust_ALLSAP') {
        //If it is search by territory
        if(reportFilters.territoryId && reportFilters.territoryId != null){
          //If it is an 'all-segments' search, then execute as a job
          if(reportFilters.majorSegments.length == 0) return {execAsJob: true, reportId: 21};

          //If more than 15 segments are selected, then execute as a job
          if(reportFilters.majorSegments.length > 15) return {execAsJob: true, reportId: 21};
        }else if(reportFilters.postCodeId){

          if(reportFilters.majorSegments.length == 0 && reportFilters.radiusMiles > 150) return {execAsJob: true, reportId: 21};

          if(reportFilters.majorSegments.length > 15 && reportFilters.radiusMiles > 150) return {execAsJob: true, reportId: 21};
        }

      }

      if(reportType == 'CurrCust_LBSAP') {
        //If it is search by territory
        if(reportFilters.territoryId && reportFilters.territoryId != null){
          //If it is an 'all-segments' search, then execute as a job
          if(reportFilters.majorSegments.length == 0) return {execAsJob: true, reportId: 22};

          //If more than 15 segments are selected, then execute as a job
          if(reportFilters.majorSegments.length > 15) return {execAsJob: true, reportId: 22};
        }else if(reportFilters.postCodeId){

          if(reportFilters.majorSegments.length == 0 && reportFilters.radiusMiles > 150) return {execAsJob: true, reportId: 22};

          if(reportFilters.majorSegments.length > 15 && reportFilters.radiusMiles > 150) return {execAsJob: true, reportId: 22};
        }
      }

      if(reportType == 'CRM_Prospects_With91MA') {

        if(reportFilters.postCodeId){

          if(reportFilters.majorSegments.length == 0 && reportFilters.radiusMiles > 100) return {execAsJob: true, reportId: 23};

          if(reportFilters.majorSegments.length > 15 && reportFilters.radiusMiles > 100) return {execAsJob: true, reportId: 23};
        }
      }

      if(reportType == 'LeadsWith91MA_AllLeadsDetails') {

        if(reportFilters.postCodeId){
          
          if(reportFilters.majorSegments.length == 0 && reportFilters.radiusMiles > 100) return {execAsJob: true, reportId: 24};

          if(reportFilters.majorSegments.length > 15 && reportFilters.radiusMiles > 100) return {execAsJob: true, reportId: 24};
        }
      }

      if(reportType == 'CRM_Suspects') {

        if(reportFilters.postCodeId){
          
          if(reportFilters.majorSegments.length == 0 && reportFilters.radiusMiles > 100) return {execAsJob: true, reportId: 25};

          if(reportFilters.majorSegments.length > 15 && reportFilters.radiusMiles > 100) return {execAsJob: true, reportId: 25};
        }
      }

      return {execAsJob: false};

  }

  

  getCurrentCustomerReport_ALLSAP(reportFilters: CRMReportRequest){

    return this.http.post<any>(this.baseurl + 'CRMSAPSalesTerrZipReport' 
      + '/getCRMCurrCustALLSAPReport', this.prepareRequest(reportFilters));      
    
  }

  getCurrentCustomerReport_LBSAP(reportFilters: CRMReportRequest){
    
    return this.http.post<any>(this.baseurl + 'CRMSAPSalesTerrZipReport' 
      + '/getCRMCurrCustLBSAPReport', this.prepareRequest(reportFilters));
    
  }

  getLeadsOLWReport_OpenLeadsDetails(reportFilters: CRMReportRequest){

    return this.http.post<any>(this.baseurl + 'CRMSAPSalesTerrZipReport' 
    + '/GetCRMLeadsOLWOpenLeadsReport', this.prepareRequest(reportFilters));
    
  }

  getLeadsWith91MA_AllLeadsDetails(reportFilters: CRMReportRequest){
    return this.http.post<any>(this.baseurl + 'CRMSAPSalesTerrZipReport' 
      + '/GetCRMLeads91MAReport', this.prepareRequest(reportFilters));
  }

  getCRMProspectsWith91MA(reportFilters: CRMReportRequest){
    return this.http.post<any>(this.baseurl + 'CRMSAPSalesTerrZipReport' 
      + '/GetCRMProspects91MAReport', this.prepareRequest(reportFilters));
  }

  getCRMSuspects(reportFilters: CRMReportRequest){
    return this.http.post<any>(this.baseurl + 'CRMSAPSalesTerrZipReport' 
      + '/GetCRMSuspectsReport', this.prepareRequest(reportFilters));
  }

  getOpptyReport_OpenOpptyDetails(reportFilters: CRMReportRequest){
    return this.http.post<any>(this.baseurl + 'CRMSAPSalesTerrZipReport' 
    + '/GetCRMOpportunitiesReport', this.prepareRequest(reportFilters));    
  }

  getTerrCountyMapInfo(reportFilters: CRMReportRequest) {
    return this.http.post<any>(this.baseurl + 'CRMSAPSalesTerrZipReport' 
    + '/GetCRMTerrCountyMapInfo', this.prepareRequest(reportFilters));
  }

  getOpptysWith91MA_AllOpptysDetails(reportFilters: CRMReportRequest){
    return this.http.post<any>(this.baseurl + 'CRMSAPSalesTerrZipReport' 
      + '/GetCRMOpp91MAReport', this.prepareRequest(reportFilters));
  }

  prepareRequest(reportFilters: CRMReportRequest){
    let filters: Object = {};

    let terrIds: Array<string> = new Array<string>();

    if(reportFilters.territoryId){
      terrIds.push(String(reportFilters.territoryId));
      filters["territoryIds"] = terrIds;
    }
     
    filters["distAdvLessThan"] = 1000;
    filters["postCodeID"] = reportFilters.postCodeId ? reportFilters.postCodeId: 0;
    filters["miles"] = reportFilters.radiusMiles ? reportFilters.radiusMiles : 0;
    filters["onlyLost"] = false;
    filters["globalIndustrySegmentIds"] = [];
    filters["majorSegmentShipToIds"] = reportFilters.majorSegments? reportFilters.majorSegments.map(id => String(id)): [];
    filters["inNextMonths"] = reportFilters.contractExpiresMonths ? reportFilters.contractExpiresMonths : 0;
    filters["competitorOrSupplier"] = reportFilters.competitorOrSupp ? reportFilters.competitorOrSupp : null;
    filters["gasPlant"] = reportFilters.gasPlant;

    return filters;
  }

}
